<template>
  <div>
    <div class="content">
      <div class="content-wrapper">
        <Loading :isActive="loading" />
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab :title="descPlural || 'Páginas'">
            <div class="filters row" style="margin-top:0">
              <div class="col-1-1">
                <div class="pull-right">
                  <CButton color="primary" @click="goToCreate">
                    <fa-icon icon="plus" />
                    Criar
                  </CButton>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div class="empty-state" v-if="!loading && items.length === 0">
              <div class="empty-icon">
                <fa-icon icon="file-alt" />
              </div>
              <h3 class="empty-title">Nenhuma página criada</h3>
              <p class="empty-desc">Crie sua primeira página para começar a publicar conteúdo no site.</p>
              <CButton color="primary" @click="goToCreate">
                <fa-icon icon="plus" />
                Criar Página
              </CButton>
            </div>

            <!-- Table -->
            <div class="table-responsive" v-if="items.length > 0">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Imagem Principal</th>
                    <th>Título</th>
                    <th>Publicação</th>
                    <th>Ativo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.id" @click="goToEdit(item)" class="row-clickable">
                    <td>
                      <div class="thumb-wrapper">
                        <img v-if="item.imagem_principal" :src="item.imagem_principal" class="thumb-img" alt="" />
                        <div v-else class="thumb-placeholder">
                          <fa-icon icon="image" />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="titulo-text">{{ item.titulo }}</div>
                      <div class="titulo-desc" v-if="item.descricao">{{ truncate(item.descricao, 80) }}</div>
                    </td>
                    <td>
                      <span v-if="item.datahora_publicacao">{{ formatDate(item.datahora_publicacao) }}</span>
                      <span class="text-muted-light" v-else>--</span>
                    </td>
                    <td>
                      <span class="label success" v-if="item.ativo">Ativo</span>
                      <span class="label error" v-else>Inativo</span>
                    </td>
                    <td class="actions" @click.stop>
                      <button type="button" class="button button-primary" @click="goToEdit(item)">
                        <fa-icon icon="pencil-alt" />
                      </button>
                      <button type="button" class="button button-error" @click="deleteConfirm(item.id)">
                        <fa-icon icon="trash-alt" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CTab>
        </CTabs>
      </div>
    </div>
  </div>
</template>

<script>
import { get, del } from '@/helpers/apiRequest';

export default {
  name: 'paginas',
  data() {
    return {
      descPlural: '',
      descSingular: '',
      loading: false,
      items: [],
    };
  },
  methods: {
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem('app'));
      const modulo = modulos.find((m) => m.nome === 'ADMIN_PAGINA');
      if (modulo) {
        this.descPlural = modulo.descPlural;
        this.descSingular = modulo.descSingular;
      }
    },
    loadPaginas() {
      this.loading = true;
      get('/admin/site-paginas')
        .then((json) => {
          this.items = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    goToCreate() {
      this.$router.push({ name: 'pagina-criar' });
    },
    goToEdit(item) {
      this.$router.push({ name: 'pagina-editar', params: { id: item.id } });
    },
    deleteConfirm(id) {
      this.$swal({
        title: 'Confirma Remover?',
        text: 'Essa ação não poderá ser desfeita',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      }).then((res) => {
        if (res.value) {
          this.loading = true;
          del(`/admin/site-paginas/${id}`)
            .then(() => {
              this.loading = false;
              this.loadPaginas();
              this.$swal({ title: 'Removido com sucesso', icon: 'success' });
            })
            .catch(() => {
              this.loading = false;
              this.$swal({ title: 'Falha ao remover', icon: 'error' });
            });
        }
      }).catch(() => {});
    },
    truncate(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
  },
  beforeMount() {
    this.loadPaginas();
    this.loadDescricaoModulo();
  },
};
</script>

<style scoped>
.row-clickable {
  cursor: pointer;
}

/* Thumbnail */
.thumb-wrapper {
  width: 52px;
  height: 38px;
  border-radius: 4px;
  overflow: hidden;
  background: #f2f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumb-placeholder {
  color: #98a2b3;
  font-size: 16px;
}

/* Title column */
.titulo-text {
  font-weight: 600;
  color: #1d2939;
}

.titulo-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}

.text-muted-light {
  color: #98a2b3;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
}

.empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: #f2f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #3a3e81;
  margin-bottom: 16px;
}

.empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2939;
  margin: 0 0 6px;
}

.empty-desc {
  font-size: 13px;
  color: #667085;
  margin: 0 0 20px;
  max-width: 320px;
}
</style>
